module.exports = __webpack_public_path__ + "static/media/edit.fe542ab4.svg";